import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MessagesService } from '@core/_services/messages.service';
import { RequestTools } from '@service/request.tools';
import { CheckTools } from '@service/check.tools';
import { bsk_delay, bsk_docdate, bsk_docstatus, bsk_mailconf, bsk_maillimit, bsk_mailurgent, doc_name } from '@documalis/_const/const';
import { EditorService } from '@service/editor.service';

@Injectable()
export class CustomService {
    public docInfos: any;
    public docVariable: any;
    public basketInfos: any;
    public basketIndex: any;
    public docAtfs: any;
    public subject: any;

    constructor(
        public requestTools: RequestTools,
        private checkTools: CheckTools,
        public editorService: EditorService,
        protected _messageService: MessagesService,
    ) {}

    public createSubject() {
        this.subject = new Subject();
    }

    public destroySubject() {
        if (this.subject && !this.subject.closed) {
            this.subject.unsubscribe();
        };
    }

    public refreshData() {
        this.subject.next();
    }
   
    public clear() {
        this.docInfos = null;
        this.docVariable = null;
        this.basketIndex = null;
        this.basketInfos = null;
        this.docAtfs = null;
    }
    
    public setBaseValues(aDocInfos, aDocVariable, aBasketIndex, aBasketInfos, aDocAtfs) {
        this.clear();
        this.docInfos = aDocInfos;
        this.docVariable = aDocVariable;
        this.basketIndex = aBasketIndex;
        this.basketInfos = aBasketInfos;
        this.docAtfs = aDocAtfs;
    }

    public getUserInfos() {
        let wInternal = JSON.parse(atob(localStorage.getItem('intern')));
        return wInternal.internal;
    }

    public async getInfosDoc(aDocId, aUser, aUpdate, aVariableStorage, aOptions) {
        let wRes: any;
        this.requestTools.setCurrentDocId(aDocId);
        wRes = await this.requestTools.getAsyncInfosDoc(aVariableStorage, aUpdate);
        if (wRes.status === false) {
            this._messageService.addErrorMsg('Erreur de récupération des données');
        } else {
            return this.getValueDoc(wRes, aOptions);
        }
    }

    public async getDocumentBasketList(aBskType, aBskName, aUser) {
        let wRes: any;
        let wRequest = {
            BskName: aBskName,
            BskType: aBskType,
            CountDoc: false,
            MaxResult: "0",
            Search: { 
                CriteriaList: [],
                ResultList: this.getColBsk(aBskType),
            },
            SearchWord: "",
            UseLock: false,
        }
        wRes = await this.requestTools.getBasketDocList(wRequest);
        if (wRes.status === false) {
            this._messageService.addErrorMsg('Erreur de récupération des données');
        } else {
            return this.getBasketList(wRes.data);
        }
    }

    public async getBasketVariableList(aBskType, aBskName, aUser, aIndex) {
        let wRes: any;
        wRes = await this.requestTools.getVariableListTransfert(aBskType, aBskName);
        if (wRes.status === false) {
            this._messageService.addErrorMsg('Erreur de récupération des données');
        } else {
            return this.getBskVarList(wRes.data, aIndex);
        }
    }
    
    private getBskVarList(aData, aIndex) {
        let wIndexBasket: any;
        wIndexBasket = {};
        let wRes = false;
        wRes = this.verifyErr(aData);
        if (wRes === false) {
            if (aData.VariableList !== undefined) {
                this.editorService.setMode(false);
                this.editorService.setBskVarListDef(aData);
                let indexBasketList = JSON.parse(
                    JSON.stringify(
                        this.editorService.formatVarList(
                            this.editorService.variableListService.execParse(aData)
                        )
                    )
                );
                wIndexBasket = JSON.parse(
                    JSON.stringify(this.editorService.prepareListVar(indexBasketList, aIndex))
                );
                return {
                    indexBskList: wIndexBasket
                }                        
            }
            return [];
        } else {
            return null;
        }
    }

    private getBasketList(aData) {
        let wDocData: any;
        wDocData = {};
        let wRes = false;
        wRes = this.verifyErr(aData);
        if (wRes === false) {
            return {
                DocCount: aData.DocCount,
                DocIDs: aData.DocIDs,
                DocumentList: aData.DocumentList,
            }                        
        } else {
            return null;
        }
    }

    private getColBsk(aBskType) {
        let wResultList = new Array();
        wResultList = [];
        wResultList.push(bsk_docdate);
        wResultList.push(doc_name);
        wResultList.push(bsk_docstatus);
   
        if (aBskType === 'btMail') {
            wResultList.push(bsk_maillimit);
            wResultList.push(bsk_mailurgent);
            wResultList.push(bsk_mailconf);
            wResultList.push(bsk_delay);
        }
        return wResultList;
    }

    private getValueDoc(aRes, aOptions) {
        let wDocData: any;
        wDocData = {};
        if (aOptions.info === true) {
            wDocData.docInfos = this.getInfo(aRes.data);
        }
        if (aOptions.index === true) {
            wDocData.docIndex = this.getIndex(aRes.data);
        }
        if (aOptions.comment === true) {
            wDocData.docComment = this.getComment(aRes.data);
        }
        if (aOptions.trace === true) {
            wDocData.docTrace = this.getTrace(aRes.data);
        }
        if (aOptions.basket === true) {
            wDocData.docBasket = this.getBasket(aRes.data);
        }
        if (aOptions.atf === true) {
            wDocData.docAtf = this.getAtf(aRes.data);
        }
        if (aOptions.version === true) {
            wDocData.docVersion = this.getVersion(aRes.data);
        }
        return wDocData;
    }

    private getInfo(aData) {
        let wRes = false;
        wRes = this.verifyErr(aData.getInfoDoc);
        if (wRes === false) {
            return aData.getInfoDoc.data;
        } else {
            return null;
        }
    }

    private getIndex(aData) {
        let wRes = false;
        wRes = this.verifyErr(aData.getIndexDoc);
        if (wRes === false) {
            return aData.getIndexDoc.VariableList;
        } else {
            return null;
        }
    }

    private getComment(aData) {
        let wRes = false;
        wRes = this.verifyErr(aData.getCommentsDoc);
        if (wRes === false) {
            return aData.getCommentsDoc.CommentList;
        } else {
            return null;
        }
    }

    private getTrace(aData) {
        let wRes = false;
        wRes = this.verifyErr(aData.getTracesDoc);
        if (wRes === false) {
            return aData.getTracesDoc.TraceList;
        } else {
            return null;
        }
    }

    private getBasket(aData) {
        let wRes = false;
        wRes = this.verifyErr(aData.getBasketsDoc);
        if (wRes === false) {
            return aData.getBasketsDoc.basketlist;
        } else {
            return null;
        }
    }

    private getAtf(aData) {
        let wRes = false;
        wRes = this.verifyErr(aData.getAtfDoc);
        if (wRes === false) {
            return aData.getAtfDoc.AtfList;
        } else {
            return null;
        }
    }

    private getVersion(aData) {
        let wRes = false;
        wRes = this.verifyErr(aData.getVersionDoc);
        if (wRes === false) {
            return aData.getVersionDoc.VersionList.Version.map((item) => {
                item.name = item.name.substring(5, 9);
                item.showVer = true;
                return item;
            });
        } else {
            return null;
        }
    }

    private verifyErr(aData) {
        let wRes = false;
        this.checkTools.checkError(aData);
        if (this.checkTools.getRes() === false) {
            this._messageService.addErrorMsg(this.checkTools.getMsg());
            wRes = true;
        }
        return wRes;
    }

}

